import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CountdownService {
    readonly pausedSubject = new BehaviorSubject(false);
    readonly restartSubject = new Subject<void>();

    pauseCountdown$ = this.pausedSubject.asObservable();
    restartCountdown$ = this.restartSubject.asObservable();

    pause(): void {
        this.pausedSubject.next(true);
    }

    restart(): void {
        this.pausedSubject.next(false);
        this.restartSubject.next();
    }
}
